<template>
  <b-container>
    <h1 class="mt-2">JSON Tools</h1>
    <JSON />
  </b-container>
</template>

<script type="ts">
import Vue from 'vue';
import JSON from '@/components/JSON.vue'

export default Vue.extend({
  components: {
    JSON
  }
})
</script>